import moment from 'moment'
moment.locale('ru')
